import { MissingItemBlock } from 'types/clientIdentification';

export const BLOCK_IDS = {
    clientAndTier: 'client-and-tier',
    clientDetails: 'client-details',
    relatedParties: 'related-parties',
    identification: 'identification',
    evidence: 'evidence',
    review: 'review',
} as const;

export type BlockId = (typeof BLOCK_IDS)[keyof typeof BLOCK_IDS];

export const BLOCK_OF_MISSING: Record<MissingItemBlock, BlockId> = {
    CLIENT_DETAILS: BLOCK_IDS.clientDetails,
    RELATED_PARTIES: BLOCK_IDS.relatedParties,
    IDENTIFICATION: BLOCK_IDS.identification,
};
